/* eslint-disable global-require */
export default {
    Cat: require('./assets/images/cat.png'),
    Dog: require('./assets/images/dog.png'),
    DownloadApp: require('./assets/images/downloadApp.png'),
    MarchingAnimals: require('./assets/images/marchingAnimals.png')
};
